import React, { Component, Fragment } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import { getPaymentInfoErrors } from "../utils";
import Form from "assets/scripts/components/common/form/Form/Form";
import PaymentInfoFields from "../PaymentInfoFields/PaymentInfoFields";
import tryParseNumber from "assets/scripts/utils/tryParseNumber";
import StatusMessage from "../../../../presentational/StatusMessage";
const messages = defineMessages({
    next: {
        id: "forms.payNow.paymentInfo.next",
        defaultMessage: "Next"
    }
});
export default class PaymentInfoForm extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            amountValid: true,
            loading: false
        };
    }
    async onSubmit() {
        if (this.props.validateAmount) {
            const amt = tryParseNumber(this.props.value.amount);
            if (amt == null) {
                this.setState({ amountValid: false });
                return;
            }
            this.setState({ loading: true });
            const valid = await this.props.validateAmount(amt);
            if (!valid) {
                this.setState({ amountValid: false, loading: false });
                return;
            }
            this.setState({ loading: false });
        }
        this.props.onContinue();
    }
    render() {
        const { props } = this;
        const errors = getPaymentInfoErrors(props.value, props.group, props.now, props.settlementOffer != null, !!this.props.validateAmount);
        const amountError = !!this.props.validateAmount && !this.state.amountValid
            ? (<FormattedMessage id="forms.payNow.amount.unexpected" defaultMessage="The amount you are trying to pay is greater than the amount we are expecting"/>)
            : null;
        return (<Fragment>
				<div className="vr vr_x4">
					<h1 className="hdg">
						<FormattedMessage id="forms.payNow.paymentInfo.legend" defaultMessage="Payment Information"/>
					</h1>
				</div>

				<Form isBusy={props.isLoading || this.state.loading} isValid={errors.valid} onSubmit={() => this.onSubmit()} submitLabel={messages.next} error={props.globalError || amountError}>
					<fieldset className="fieldset fieldset-depth-0">
						<PaymentInfoFields errors={errors} {...props}/>
					</fieldset>
				</Form>
				<div>
					<StatusMessage isLoad isActive={this.state.loading ? true : false}/>
				</div>
			</Fragment>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/PaymentInfoForm/PaymentInfoForm.tsx